export class Emi {
    tipoDocId: string;
    numeroDocId: string;
    direccion: string;
    razonSocial: string;
    ubigeo: string;
    codigoAsigSUNAT: string;
    departamento: string;
    telefono: string;


    constructor(numeroDocId: string,
                razonSocial: string,
                tipoDocId: string = '6',
                direccion: string = '#direccion#',
                ubigeo: string = null,
                codigoAsigSUNAT: string = '0000',
                departamento: string = null,
                telefono: string = null) {
        this.tipoDocId = tipoDocId;
        this.numeroDocId = numeroDocId;
        this.direccion = direccion;
        this.razonSocial = razonSocial;
        this.ubigeo = ubigeo;
        this.codigoAsigSUNAT = codigoAsigSUNAT;
        this.departamento = departamento;
        this.telefono = telefono;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/Emi.ts